import React from "react";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import HomePage from "../pages/HomePage";
import MainLayout from "../layouts/MainLayout";
import PackageDetailsPage from "../pages/PackageDetailsPage";
import DestinationDetailsPage from "../pages/DestinationDetailsPage";
import Destinations from "../pages/Destinations";
import Packages from "../pages/PackagesPage";
import ContactPage from "../pages/ContactPage";
import TermsAndConditions from "../pages/TermsAndConditionsPage";

const router = createBrowserRouter(
  createRoutesFromElements([
    <Route key="layout" path="/" element={<MainLayout />}>
      <Route key="home-page" index path="" element={<HomePage />} />,
      <Route
        key="package-details"
        path="package/:id"
        element={<PackageDetailsPage />}
      />
      <Route
        key="destination-details"
        path="destination/:id"
        element={<DestinationDetailsPage />}
      />
      <Route
        key="destinations"
        path="destinations"
        element={<Destinations />}
      />
      <Route key="packages" path="packages" element={<Packages />} />,
      <Route key="contact-page" path="contact" element={<ContactPage />} />,
      <Route key="terms-and-conditions" path="terms-and-conditions" element={<TermsAndConditions />} />,
    </Route>,
  ])
);

export default router;
